import { STATUS_TYPE } from '../../../enum';
import { PropertyCategory } from '../../propertyCategory/api/interface';
import { PropertySubCategory } from '../../propertySubCategory/api/interface';

export interface GetPropertyFacility {
  id: string;
}

// export interface IInitialState {
//   id?: string;
//   labelEn: string;
//   labelAr: string;
//   position: string;
//   icon: string;
//   activeState: boolean;
// }

export interface FindPropertyFacility {
  activeOnly?: boolean;
  search?: string;
  propertyCategoryId?: string;
  propertySubCategoryId?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchPropertyFacility {
  id?: string;
  labelEn: string;
  labelAr: string;
  subLabelEn: string;
  subLabelAr: string;
  icon: string;
  position: string;
  activeState: boolean;
  propertyCategoryIds: string[];
  propertySubCategoryIds: string[];
  propertyFacilityId?: string;
}

export interface PropertyFacility {
  id: string;
  labelEn: string;
  labelAr: string;
  subLabelEn: string;
  subLabelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  propertyCategoryIds: string[];
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
  propertyFacilityMapper: PropertyFacilityMapper[];
  propertyFacilitySubCategoryMapper: PropertySubFacilityMapper[];
}

export interface PropertyFacilityMapper {
  id?: string,
  propertyFacilityId?: string,
  propertyCategoryId?: string,
  property_category: PropertyCategory;
}

export interface PropertySubFacilityMapper {
  id?: string,
  propertyFacilityId?: string,
  propertySubCategoryId?: string,
  property_sub_category: PropertySubCategory;
}

interface InitialState {
  data: PropertyFacility[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};




